<template lang="pug">
  dv-form(
    ref="form"
    v-model="formData"
    :schema="schema"
    :nestable="nestable"
    v-slot="{ fields, errors }"
  )
    v-sheet(
      width="100%"
      color="trasparent"
    )
      dv-form-field(
        ref="fieldText"
        :value="image && image.name"
        :readonly="!!image"
        :error-messages="getErrors({ errors })"
        :field="fields.text"
        :loading="loading"
        :label="label"
        clearable
      )
        template(
          v-if="image"
          v-slot:prepend-inner
        )
          v-menu(
            nudge-top="12px"
            open-on-hover
            rounded="xl"
            offset-y
            top
          )
            template(v-slot:activator="{ on, attrs }")
              v-avatar.mr-1(
                v-bind="attrs"
                v-on="on"
                :size="36"
                rounded="4"
                style="top: -2px; left: -6px; z-index: 1;"
              )
                v-img(
                  :src="image.url"
                )

            v-img(
              :max-height="164"
              :max-width="260"
              :src="image.url"
            )

        template(
          v-if="!formData[textKey] && !image"
          v-slot:append
        )
          dv-form-nested(
            :field="fields.image"
            v-slot="{ pickFile }"
          )
            v-icon.ml-2(
              color="ui-neutral lighten-1"
              @click="pickFile"
            ) $ui-photo
</template>

<script>
import DvForm from '../forms/DvForm.vue';
import DvTextField from './DvTextField.vue';
import DvFormField from '../forms/DvFormField.vue';
import DvFileUploader from './uploaders/DvFileUploader.vue';
import DvFormNested from '../forms/DvFormNested.vue';

export default {
  components: {
    DvTextField,
    DvFileUploader,
    DvFormField,
    DvFormNested,
    DvForm,
  },
  inject: {
    getParentFormData: {
      from: 'getFormData',
      default: null,
    },
  },
  props: {
    rules: {
      type: [String, Object],
      default: undefined,
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
    returnMultiple: {
      type: Boolean,
      default: false,
    },
    nestable: {
      type: Boolean,
      default: true,
    },
    textKey: {
      type: String,
      default: 'name',
    },
    imageKey: {
      type: String,
      default: 'image',
    },
    label: {
      type: String,
      default: undefined,
    },
    value: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      formData: {},
      inputValue: undefined,
      loading: false,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.formData = this.nestable ? this.getParentFormData() : val || {};
      },
      immediate: true,
    },
    formData(val) {
      if (this.nestable) return;

      this.$emit('input', val);
    },
  },
  computed: {
    schema() {
      const {
        textKey,
        imageKey,
        formData,
        returnMultiple,
      } = this;

      return [
        {
          name: 'text',
          value: this.textKey,
          rules: 'required_fill',
          component: DvTextField,
          listeners: {
            'click:clear': () => {
              const { $refs } = this;

              $refs.form.reset({
                [imageKey]: returnMultiple ? [] : null,
                [textKey]: null,
              });
            },
          },
        },
        {
          name: 'image',
          value: imageKey,
          component: DvFileUploader,
          listeners: {
            input: (val) => {
              this.$set(formData, imageKey, val);
            },
            loading: (val) => {
              this.loading = val;
            },
          },
          props: {
            rules: 'mimes:image/*',
            returnMultiple,
            serializeData: ({ data }) => ({
              name: data.file_name,
              url: data.url,
            }),
          },
        },
      ];
    },
    image() {
      const { imageKey } = this;
      const first = 0;
      return [].concat(this.formData[imageKey]).at(first);
    },
  },
  methods: {
    getErrors({ errors }) {
      const { textKey, imageKey, formData } = this;

      if (errors[imageKey]?.length && !formData[textKey]) {
        return errors[imageKey];
      }

      return errors[textKey];
    },
  },
};
</script>
